module.exports = __webpack_public_path__ + "media/img/frontend_application/bottomnav/profile-97403062e34c925a4ccc5d8c521e7e39.svg";